
import Vue, { PropType } from 'vue'
import {
  AlertTypes,
  AlertInterface
} from '@whitelist/wl-old-library/components/global/alert/types'

type InternalActionPositions = Required<Required<AlertInterface>['action']>['position'] | 'none'

export default Vue.extend({
  name: 'alertComponent',
  props: {
    alertType: {
      type: String as PropType<AlertInterface['type']>,
      required: true
    },
    alertTitle: {
      type: String as PropType<AlertInterface['title']>,
      required: true
    },
    alertID: {
      type: String as PropType<AlertInterface['id']>,
      required: false
    },
    onlyContent: {
      type: Boolean as PropType<AlertInterface['onlyContent']>,
      default: false
    },
    content: {
      type: String as PropType<AlertInterface['content']>,
      default: ''
    },
    deletable: {
      type: Boolean as PropType<AlertInterface['deletable']>,
      default: true
    },
    action: {
      type: Object as PropType<AlertInterface['action']>,
      default: undefined
    },
    fillWidth: {
      type: Boolean as PropType<AlertInterface['fillWidth']>,
      default: false
    },
    wordBreak: {
      type: Boolean as PropType<AlertInterface['wordBreak']>,
      default: false
    },
    messages: {
      type: Array as PropType<AlertInterface['messages']>,
      default: () => []
    },
    contentType: {
      type: String as PropType<'html' | 'text'>,
      default: 'text'
    }
  },
  computed: {
    getCurrentIcon (): string {
      const vm = this as any
      switch (vm.alertType) {
        case (AlertTypes.info): return ''
        case (AlertTypes.warning): return ''
        case (AlertTypes.error): return ''
        case (AlertTypes.success): return ''
        default: return ''
      }
    },
    getCurrentColor (): string {
      const vm = this as any
      switch (vm.alertType) {
        case (AlertTypes.info): return vm.getColor('ACCENT.BLUE_LIGHT_1')
        case (AlertTypes.warning): return vm.getColor('ACCENT.YELLOW')
        case (AlertTypes.error): return vm.getColor('ACCENT.RED_LIGHT')
        case (AlertTypes.success): return vm.getColor('ACCENT.GREEN_LIGHT')
        default: return ''
      }
    },
    actionPosition (): InternalActionPositions {
      if (this.action === undefined) return 'none'
      if (this.action.position === undefined) return 'top'
      if (this.action.position === 'top') return 'top'

      return 'bottom'
    }
  },
  methods: {
    removeAlert () {
      this.$store.dispatch('alertsBus/removeAlert', this.alertID)
    }
  }
})
